document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('[data-mega-menu]');
  if (!nav) return;

  const items = nav.querySelectorAll(':scope > li');

  items.forEach((item, idx) => {
    const dropdown = item.querySelector('[data-mega-dropdown]');
    if (!dropdown) return;

    let enterTimer;
    let leaveTimer;

    item.addEventListener('mouseenter', () => {
      clearTimeout(leaveTimer);
      enterTimer = setTimeout(() => {
        positionDropdown(item, dropdown, idx, items.length);
        dropdown.classList.add('is-active');
      }, 60);
    });

    item.addEventListener('mouseleave', () => {
      clearTimeout(enterTimer);
      leaveTimer = setTimeout(() => {
        dropdown.classList.remove('is-active');
      }, 120);
    });
  });
});

function positionDropdown(item, dropdown, idx, total) {
  const itemRect = item.getBoundingClientRect();
  const vpWidth  = window.innerWidth;
  const padding  = 12;
  const maxWidth = 1260;
  const width    = Math.min(maxWidth, vpWidth - padding * 2);

  let left;
  if (idx <= 2) {
    left = itemRect.left;
  } else if (idx >= total - 2) {
    left = itemRect.right - width;
  } else {
    left = itemRect.left + itemRect.width / 2 - width / 2;
  }

  left = Math.max(padding, Math.min(left, vpWidth - width - padding));

  dropdown.style.position = 'fixed';
  dropdown.style.left  = `${left}px`;
  dropdown.style.top   = `${itemRect.bottom}px`;
  dropdown.style.width = `${width}px`;
}
